const LocationIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="10"
          cy="9.1665"
          r="2.5"
          stroke="currentColor"
          stroke-width="1.5"
        />
        <path
          d="M17.5 9.07391C17.5 13.1649 12.8125 18.3332 10 18.3332C7.1875 18.3332 2.5 13.1649 2.5 9.07391C2.5 4.98291 5.85786 1.6665 10 1.6665C14.1421 1.6665 17.5 4.98291 17.5 9.07391Z"
          stroke="currentColor"
          stroke-width="1.5"
        />
      </svg>
    </div>
  );
};

export default LocationIcon;
